export function mapPartyIdentificationForSubmit(data) {
  const partyIdentificationId = data.party_identification_id?.trim?.() ?? data.party_identification_id ?? '';

  return {
    party_identification_id: partyIdentificationId,
    party_identification_scheme_id: data.party_identification_scheme_id?.code ?? '',
  };
}
